// src/components/Layout.jsx
import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";

const DRAWER_WIDTH = 0;
const MINI_WIDTH = 0;

export default function Layout() {
  // sidebar persist
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    try {
      return localStorage.getItem("sidebar_open") !== "0";
    } catch (e) {
      return true;
    }
  });

  const toggleSidebar = () => {
    setSidebarOpen((s) => {
      const next = !s;
      try {
        localStorage.setItem("sidebar_open", next ? "1" : "0");
      } catch (e) {}
      return next;
    });
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* Fixed Header */}
      <Header onToggle={toggleSidebar} />

      {/* Sidebar */}
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: "70px", // header height
          ml: sidebarOpen ? `${DRAWER_WIDTH}px` : `${MINI_WIDTH}px`,
          transition: "all 0.3s ease-in-out",
          p: 2,
        }}
      >
        {/* Page content */}
        <Outlet />
      </Box>
    </Box>
  );
}
